/* @flow */

import { get } from 'lodash/fp';

import { USER_SIGN_IN } from '../constants/apiTypes';
import { API_CALL_SUCCESS } from '../constants/actionTypes';
import { submitSuperoverScore } from '../actions/promotionsActions';

type Callback = any => any;
type StoreObj = {
  dispatch: Dispatch<*>,
  getState: () => GlobalState
};

function promotionsMiddleware() {
  return ({ dispatch, getState }: StoreObj) => (next: Callback) => (action: any) => {
    const { route } = getState();
    const superoverToken = get('superover_token', route.query);
    if (action.type === API_CALL_SUCCESS) {
      switch (action.api) {
        case USER_SIGN_IN:
          if (superoverToken) {
            dispatch(
              submitSuperoverScore({
                token: superoverToken
              })
            );
          }
          break;
        default:
      }
    }

    return next(action);
  };
}

export default promotionsMiddleware;
